import styled from "styled-components";

import { Table } from "../../../components/PartnerDashboard/ui";

export const StackTable = styled(Table)`
  @media (max-width: 960px) {
    thead {
      display: none;
    }

    tr {
      display: block;
      padding: 12px 0;
      border-bottom: 1px solid #f3eee7;
    }

    td {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 12px;
      padding: 5px 0;
      border-bottom: none;
      white-space: normal;
      text-align: right;
      min-width: 0;
      overflow-wrap: anywhere;
    }

    td[data-label]::before {
      content: attr(data-label);
      flex-shrink: 0;
      font-size: 12px;
      font-weight: 600;
      color: #9a8e84;
      text-align: left;
    }

    td:not([data-label]) {
      display: block;
      text-align: left;
      padding-bottom: 6px;
    }
  }
`;

export const MetricGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(170px, 1fr));
  gap: 12px;

  @media (max-width: 480px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
  }
`;

export const Metric = styled.div`
  background: #ffffff;
  border: 1px solid #ece4da;
  border-radius: 14px;
  padding: 14px 16px;
  font-family: 'Aileron', 'Poppins', sans-serif;
  min-width: 0;
`;

export const MetricValue = styled.div`
  font-size: 24px;
  font-weight: 800;
  color: #111111;
  line-height: 1.1;
  overflow-wrap: anywhere;

  @media (max-width: 480px) {
    font-size: 20px;
  }
`;

export const MetricLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  font-size: 12.5px;
  font-weight: 600;
  color: #6b6259;
  margin-top: 6px;
`;

export const ActionRow = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`;
